// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
   SETTINGS MODAL — VERSION AMÉLIORÉE
   Couleur accent : Indigo #6366f1
   Fond : Bleu-noir profond #16181f
   Police : DM Sans (Google Fonts)
   ============================================= */

/* Import de la police — à ajouter dans votre <head> HTML :
   <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&display=swap" rel="stylesheet"> */



/* ---- Overlay ---- */
.settings-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* ---- Modal ---- */
.settings-modal {
  background: #16181f;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow:
    0 32px 64px rgba(0, 0, 0, 0.6),
    0 0 0 1px rgba(255, 255, 255, 0.04);
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  font-family: 'DM Sans', sans-serif;
  animation: slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ---- Header ---- */
.settings-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 24px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: linear-gradient(180deg, rgba(99, 102, 241, 0.08) 0%, transparent 100%);
}

.settings-modal-header h2 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #f0f0f5;
  letter-spacing: -0.2px;
}

.close-button {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.5);
  font-size: 18px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
  line-height: 1;
}

.close-button:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.15);
}

/* ---- Content ---- */
.settings-modal-content {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1 1;
}

/* ---- Section ---- */
.settings-section {
  margin-bottom: 20px;
}

.settings-section:last-child {
  margin-bottom: 0;
}

.settings-section h3 {
  margin: 0 0 12px 0;
  font-size: 11px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.35);
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

/* ---- Setting Item ---- */
.settings-setting-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  margin-bottom: 8px;
  transition: background 0.2s, border-color 0.2s;
  cursor: pointer;
}

.settings-setting-item:last-child {
  margin-bottom: 0;
}

.settings-setting-item:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(99, 102, 241, 0.3);
}

/* ---- Toggle Switch (remplace la checkbox basique) ---- */
.setting-toggle {
  position: relative;
  width: 38px;
  height: 22px;
  flex-shrink: 0;
  margin-top: 1px;
}

.setting-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.toggle-track {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 11px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
  transition: background 0.25s, border-color 0.25s;
}

.toggle-track::after {
  content: '';
  position: absolute;
  left: 3px;
  top: 3px;
  width: 14px;
  height: 14px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  transition: left 0.25s, background 0.25s;
}

.setting-toggle input:checked + .toggle-track {
  background: #6366f1;
  border-color: #6366f1;
}

.setting-toggle input:checked + .toggle-track::after {
  left: 19px;
  background: #1b1919;
}

/* ---- Si vous gardez les checkboxes classiques ---- */
.setting-label {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.setting-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #6366f1;
  border-radius: 4px;
}

/* ---- Textes ---- */
.setting-text {
  font-size: 14px;
  color: #e0e0ea;
  font-weight: 500;
}

.setting-description {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.38);
  line-height: 1.5;
}

/* ---- Info Block ---- */
.settings-info {
  padding: 14px 16px;
  background: rgba(99, 102, 241, 0.08);
  border: 1px solid rgba(99, 102, 241, 0.2);
  border-radius: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  line-height: 1.6;
  text-align: center;
}

.color-picker-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
  width: 100%;
}

.color-option {
  width: 100%;
  padding-bottom: 100%;
  border-radius: 8px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.color-option:hover {
  transform: scale(1.05);
  border-color: rgba(255, 255, 255, 0.3);
}

.color-option.selected {
  border-color: #ffffff;
  box-shadow: 0 0 0 2px #6366f1;
}

/* ---- Meeting Info ---- */
.meeting-info {
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
}

.meeting-info p {
  margin: 5px 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
}

.meeting-info p:first-child { margin-top: 0; }
.meeting-info p:last-child  { margin-bottom: 0; }

.meeting-info strong {
  color: #e0e0ea;
  font-weight: 500;
}

/* ---- Footer ---- */
.settings-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(0, 0, 0, 0.2);
}

/* ---- Bouton Secondaire ---- */
.btn-secondary {
  padding: 9px 18px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.2);
}

/* ---- Bouton Primaire ---- */
.btn-primary {
  padding: 9px 20px;
  background: #6366f1;
  border: 1px solid transparent;
  border-radius: 10px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  letter-spacing: -0.1px;
  transition: background 0.2s, box-shadow 0.2s, transform 0.15s;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);
}

.btn-primary:hover {
  background: #5254cc;
  box-shadow: 0 6px 18px rgba(99, 102, 241, 0.45);
  transform: translateY(-1px);
}

.btn-primary:active {
  transform: translateY(0);
}

/* ---- Scrollbar ---- */
.settings-modal-content::-webkit-scrollbar {
  width: 5px;
}

.settings-modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.settings-modal-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 3px;
}

.settings-modal-content::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25);
}

@media (max-width: 768px) {
  .settings-modal {
    width: 95%;
    max-width: 95%;
    border-radius: 16px;
  }

  .settings-modal-header {
    padding: 18px 20px 16px;
  }

  .settings-modal-header h2 {
    font-size: 16px;
  }

  .settings-modal-content {
    padding: 16px 20px;
  }

  .settings-section h3 {
    font-size: 10px;
  }

  .settings-setting-item {
    padding: 12px 14px;
    gap: 12px;
  }

  .setting-text {
    font-size: 13px;
  }

  .setting-description {
    font-size: 11px;
  }

  .meeting-info p {
    font-size: 12px;
  }

  .settings-modal-footer {
    padding: 14px 20px;
  }
}

@media (max-width: 480px) {
  .settings-modal {
    width: 100%;
    max-width: 100%;
    border-radius: 0;
    height: 100vh;
    max-height: 100vh;
  }

  .settings-modal-header {
    padding: 16px 18px;
  }

  .close-button {
    width: 28px;
    height: 28px;
    font-size: 16px;
  }

  .settings-modal-content {
    padding: 14px 16px;
  }

  .setting-toggle {
    width: 32px;
    height: 18px;
  }

  .toggle-track::after {
    width: 12px;
    height: 12px;
  }

  .btn-secondary,
  .btn-primary {
    padding: 8px 16px;
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal.css"],"names":[],"mappings":"AAAA;;;;;kDAKkD;;AAElD;kHACkH;;;;AAIlH,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C;;uCAEqC;EACrC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,sDAAsD;AACxD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,kDAAkD;EAClD,kFAAkF;AACpF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,uCAAuC;AACzC;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oCAAoC;EACpC,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;;AAEA,8BAA8B,aAAa,EAAE;AAC7C,8BAA8B,gBAAgB,EAAE;;AAEhD;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,0DAA0D;AAC5D;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,sCAAsC;AACxC;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,sBAAsB;EACtB,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["/* =============================================\r\n   SETTINGS MODAL — VERSION AMÉLIORÉE\r\n   Couleur accent : Indigo #6366f1\r\n   Fond : Bleu-noir profond #16181f\r\n   Police : DM Sans (Google Fonts)\r\n   ============================================= */\r\n\r\n/* Import de la police — à ajouter dans votre <head> HTML :\r\n   <link href=\"https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&display=swap\" rel=\"stylesheet\"> */\r\n\r\n\r\n\r\n/* ---- Overlay ---- */\r\n.settings-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.75);\r\n  backdrop-filter: blur(4px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 2000;\r\n  animation: fadeIn 0.2s ease-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to   { opacity: 1; }\r\n}\r\n\r\n/* ---- Modal ---- */\r\n.settings-modal {\r\n  background: #16181f;\r\n  border-radius: 20px;\r\n  border: 1px solid rgba(255, 255, 255, 0.08);\r\n  box-shadow:\r\n    0 32px 64px rgba(0, 0, 0, 0.6),\r\n    0 0 0 1px rgba(255, 255, 255, 0.04);\r\n  width: 90%;\r\n  max-width: 500px;\r\n  max-height: 80vh;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  font-family: 'DM Sans', sans-serif;\r\n  animation: slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1);\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(16px) scale(0.98);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n/* ---- Header ---- */\r\n.settings-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 22px 24px 20px;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\r\n  background: linear-gradient(180deg, rgba(99, 102, 241, 0.08) 0%, transparent 100%);\r\n}\r\n\r\n.settings-modal-header h2 {\r\n  margin: 0;\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n  color: #f0f0f5;\r\n  letter-spacing: -0.2px;\r\n}\r\n\r\n.close-button {\r\n  background: rgba(255, 255, 255, 0.06);\r\n  border: 1px solid rgba(255, 255, 255, 0.08);\r\n  border-radius: 8px;\r\n  color: rgba(255, 255, 255, 0.5);\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background 0.2s, color 0.2s, border-color 0.2s;\r\n  line-height: 1;\r\n}\r\n\r\n.close-button:hover {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: #ffffff;\r\n  border-color: rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n/* ---- Content ---- */\r\n.settings-modal-content {\r\n  padding: 20px 24px;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n/* ---- Section ---- */\r\n.settings-section {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.settings-section:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.settings-section h3 {\r\n  margin: 0 0 12px 0;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: rgba(255, 255, 255, 0.35);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.8px;\r\n}\r\n\r\n/* ---- Setting Item ---- */\r\n.settings-setting-item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 14px;\r\n  padding: 14px 16px;\r\n  background: rgba(255, 255, 255, 0.03);\r\n  border: 1px solid rgba(255, 255, 255, 0.06);\r\n  border-radius: 12px;\r\n  margin-bottom: 8px;\r\n  transition: background 0.2s, border-color 0.2s;\r\n  cursor: pointer;\r\n}\r\n\r\n.settings-setting-item:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.settings-setting-item:hover {\r\n  background: rgba(255, 255, 255, 0.05);\r\n  border-color: rgba(99, 102, 241, 0.3);\r\n}\r\n\r\n/* ---- Toggle Switch (remplace la checkbox basique) ---- */\r\n.setting-toggle {\r\n  position: relative;\r\n  width: 38px;\r\n  height: 22px;\r\n  flex-shrink: 0;\r\n  margin-top: 1px;\r\n}\r\n\r\n.setting-toggle input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n  position: absolute;\r\n}\r\n\r\n.toggle-track {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border-radius: 11px;\r\n  border: 1px solid rgba(255, 255, 255, 0.12);\r\n  cursor: pointer;\r\n  transition: background 0.25s, border-color 0.25s;\r\n}\r\n\r\n.toggle-track::after {\r\n  content: '';\r\n  position: absolute;\r\n  left: 3px;\r\n  top: 3px;\r\n  width: 14px;\r\n  height: 14px;\r\n  background: rgba(255, 255, 255, 0.5);\r\n  border-radius: 50%;\r\n  transition: left 0.25s, background 0.25s;\r\n}\r\n\r\n.setting-toggle input:checked + .toggle-track {\r\n  background: #6366f1;\r\n  border-color: #6366f1;\r\n}\r\n\r\n.setting-toggle input:checked + .toggle-track::after {\r\n  left: 19px;\r\n  background: #1b1919;\r\n}\r\n\r\n/* ---- Si vous gardez les checkboxes classiques ---- */\r\n.setting-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.setting-label input[type=\"checkbox\"] {\r\n  width: 18px;\r\n  height: 18px;\r\n  cursor: pointer;\r\n  accent-color: #6366f1;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* ---- Textes ---- */\r\n.setting-text {\r\n  font-size: 14px;\r\n  color: #e0e0ea;\r\n  font-weight: 500;\r\n}\r\n\r\n.setting-description {\r\n  margin: 4px 0 0 0;\r\n  font-size: 12px;\r\n  color: rgba(255, 255, 255, 0.38);\r\n  line-height: 1.5;\r\n}\r\n\r\n/* ---- Info Block ---- */\r\n.settings-info {\r\n  padding: 14px 16px;\r\n  background: rgba(99, 102, 241, 0.08);\r\n  border: 1px solid rgba(99, 102, 241, 0.2);\r\n  border-radius: 12px;\r\n  color: rgba(255, 255, 255, 0.6);\r\n  font-size: 13px;\r\n  line-height: 1.6;\r\n  text-align: center;\r\n}\r\n\r\n.color-picker-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(6, 1fr);\r\n  gap: 8px;\r\n  width: 100%;\r\n}\r\n\r\n.color-option {\r\n  width: 100%;\r\n  padding-bottom: 100%;\r\n  border-radius: 8px;\r\n  border: 2px solid transparent;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  position: relative;\r\n}\r\n\r\n.color-option:hover {\r\n  transform: scale(1.05);\r\n  border-color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.color-option.selected {\r\n  border-color: #ffffff;\r\n  box-shadow: 0 0 0 2px #6366f1;\r\n}\r\n\r\n/* ---- Meeting Info ---- */\r\n.meeting-info {\r\n  padding: 14px 16px;\r\n  background: rgba(255, 255, 255, 0.03);\r\n  border: 1px solid rgba(255, 255, 255, 0.06);\r\n  border-radius: 12px;\r\n}\r\n\r\n.meeting-info p {\r\n  margin: 5px 0;\r\n  font-size: 13px;\r\n  color: rgba(255, 255, 255, 0.55);\r\n}\r\n\r\n.meeting-info p:first-child { margin-top: 0; }\r\n.meeting-info p:last-child  { margin-bottom: 0; }\r\n\r\n.meeting-info strong {\r\n  color: #e0e0ea;\r\n  font-weight: 500;\r\n}\r\n\r\n/* ---- Footer ---- */\r\n.settings-modal-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n  padding: 16px 24px;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\r\n  background: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* ---- Bouton Secondaire ---- */\r\n.btn-secondary {\r\n  padding: 9px 18px;\r\n  background: transparent;\r\n  border: 1px solid rgba(255, 255, 255, 0.1);\r\n  border-radius: 10px;\r\n  color: rgba(255, 255, 255, 0.6);\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  font-family: 'DM Sans', sans-serif;\r\n  transition: background 0.2s, color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: rgba(255, 255, 255, 0.05);\r\n  color: #ffffff;\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n/* ---- Bouton Primaire ---- */\r\n.btn-primary {\r\n  padding: 9px 20px;\r\n  background: #6366f1;\r\n  border: 1px solid transparent;\r\n  border-radius: 10px;\r\n  color: #ffffff;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  font-family: 'DM Sans', sans-serif;\r\n  letter-spacing: -0.1px;\r\n  transition: background 0.2s, box-shadow 0.2s, transform 0.15s;\r\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: #5254cc;\r\n  box-shadow: 0 6px 18px rgba(99, 102, 241, 0.45);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.btn-primary:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n/* ---- Scrollbar ---- */\r\n.settings-modal-content::-webkit-scrollbar {\r\n  width: 5px;\r\n}\r\n\r\n.settings-modal-content::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.settings-modal-content::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.15);\r\n  border-radius: 3px;\r\n}\r\n\r\n.settings-modal-content::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.25);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .settings-modal {\r\n    width: 95%;\r\n    max-width: 95%;\r\n    border-radius: 16px;\r\n  }\r\n\r\n  .settings-modal-header {\r\n    padding: 18px 20px 16px;\r\n  }\r\n\r\n  .settings-modal-header h2 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .settings-modal-content {\r\n    padding: 16px 20px;\r\n  }\r\n\r\n  .settings-section h3 {\r\n    font-size: 10px;\r\n  }\r\n\r\n  .settings-setting-item {\r\n    padding: 12px 14px;\r\n    gap: 12px;\r\n  }\r\n\r\n  .setting-text {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .setting-description {\r\n    font-size: 11px;\r\n  }\r\n\r\n  .meeting-info p {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .settings-modal-footer {\r\n    padding: 14px 20px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .settings-modal {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    border-radius: 0;\r\n    height: 100vh;\r\n    max-height: 100vh;\r\n  }\r\n\r\n  .settings-modal-header {\r\n    padding: 16px 18px;\r\n  }\r\n\r\n  .close-button {\r\n    width: 28px;\r\n    height: 28px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .settings-modal-content {\r\n    padding: 14px 16px;\r\n  }\r\n\r\n  .setting-toggle {\r\n    width: 32px;\r\n    height: 18px;\r\n  }\r\n\r\n  .toggle-track::after {\r\n    width: 12px;\r\n    height: 12px;\r\n  }\r\n\r\n  .btn-secondary,\r\n  .btn-primary {\r\n    padding: 8px 16px;\r\n    font-size: 12px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
